import { Directive} from '@angular/core';
import { TemplateRefDirective } from 'src/app/utils/template-ref-directive';

@Directive({
    selector: '[appListingAboveSearchbarContent]',
    standalone: false
})
export class ListingAboveSearchbarContentDirective extends TemplateRefDirective {
}
